<div class="media-dialog-container">
  <h2>Send Media</h2>
  <button [attr.guide]="'media-picker-dialog-btn-1' + '__' + sanitizedUrl" mat-icon-button class="close-button" (click)="closeAll()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="media-upload-section" (click)="myInputVariable.nativeElement.click()">
    <div class="upload-box" >
      <p>Select {{selectedType}}</p>
    </div>
    <input [attr.guide]="'media-picker-dialog-inp-mediaupload' + '__' + sanitizedUrl" #myInput id="mediaUpload" type="file" ng2FileSelect [uploader]="uploader" 
           [accept]="getAcceptedFileTypes()" hidden (change)="upload()" />
  </div>

  <div *ngIf="uploadInProgress">
    <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
  </div>

  <div *ngIf="uploadedMediaUrl" class="media-preview">
    <img *ngIf="uploadedMediaType === 'image'" [src]="uploadedMediaUrl" class="preview-media">
    <video *ngIf="uploadedMediaType === 'video'" controls class="preview-media">
      <source [src]="uploadedMediaUrl" [type]="mimeType">
    </video>
    <audio *ngIf="uploadedMediaType === 'audio'" controls class="preview-media">
      <source [src]="uploadedMediaUrl" [type]="mimeType">
    </audio>
    <a *ngIf="uploadedMediaType === 'document'" [href]="uploadedMediaUrl" target="_blank">View Document</a>
  </div>

  <mat-form-field appearance="outline" class="caption-box">
    <mat-label>Caption/Text</mat-label>
    <input [attr.guide]="'media-picker-dialog-inp-2' + '__' + sanitizedUrl" matInput [(ngModel)]="caption" />
  </mat-form-field>

  <div class="action-buttons">
    <button [attr.guide]="'media-picker-dialog-btn-3' + '__' + sanitizedUrl" mat-raised-button color="primary" (click)="close()">Send</button>
    <button [attr.guide]="'media-picker-dialog-btn-4' + '__' + sanitizedUrl" mat-raised-button color="warn" (click)="closeAll()">Cancel</button>
  </div>
</div>